// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"82ff8704","977":"ad4c3d92"}[chunkId] + ".chunk.js";
};